<template>
  <a @click="triggerAction">
    <MIcon name="merge" class="action-menu-icon" />
    <span class="ml-1 action-menu-text">
      {{ __tc('reconcile') }}
    </span>
    <FlotoDrawer :open="showDrawer" width="65%" @hide="hideDrawer">
      <template v-slot:title>
        {{ __tc('reconcile') }} {{ $tc('asset') }} {{ asset.name }}:
        {{ asset.displayName }}
      </template>
      <AssetSelectionList
        hide-search-selector
        selectable
        :exclude-items-by-id="[asset.id]"
        :module-name="moduleName"
        searchable
        :max-allowed-selection="1"
        :fetch-fn="fetchPurchaseOriginAssets"
        @selection-change="setSelectedItems"
      />
      <template v-slot:actions="{ hide }">
        <MButton
          :disabled="selectedItems.length === 0"
          outline
          class="mr-2"
          :loading="processing"
          @click="handleReconcile"
        >
          {{ __tc('reconcile') }}
        </MButton>
        <MButton variant="default" @click="hide">
          {{ $t('cancel') }}
        </MButton>
      </template>
    </FlotoDrawer>
  </a>
</template>

<script>
import CloneDeep from 'lodash/cloneDeep'
import AssetSelectionList from '@components/item-selection-list/asset-list'
import { searchAssetsApi, reconcileAssetApi } from '@modules/asset/asset-api'
import { transformSearchCriteriaForServer } from '@data/search'
export default {
  name: 'ReconcileDrawer',
  components: { AssetSelectionList },
  props: {
    asset: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      showDrawer: false,
      processing: false,
      selectedItems: [],
    }
  },
  methods: {
    triggerAction() {
      this.$emit('trigger')
      // show modal after dropdown is hide
      setTimeout(() => {
        this.showDrawer = true
      }, 400)
    },
    setSelectedItems(items) {
      this.selectedItems = items
    },
    fetchPurchaseOriginAssets(_, searchCriteria, limit, offset) {
      const criterias = CloneDeep(searchCriteria)
      const q = transformSearchCriteriaForServer(this.moduleName, {
        operator: { value: 'equal' },
        paramName: 'origin',
        value: 'purchase',
        valueType: 'enum',
      })
      criterias.quals.push(q)
      return searchAssetsApi(this.moduleName, criterias, limit, offset)
    },
    handleReconcile() {
      if (this.processing) {
        return
      }
      this.processing = true
      const selectedItemIds = this.selectedItems.map((i) => i.id)
      return reconcileAssetApi(this.moduleName, [
        ...selectedItemIds,
        this.asset.id,
      ])
        .then(() => {
          this.$emit('refresh')
          this.processing = false
          this.hideDrawer()
        })
        .catch(() => {
          this.processing = false
        })
    },
    hideDrawer() {
      this.selectedItems = []
      this.showDrawer = false
    },
  },
}
</script>
